export default __webpack_public_path__ + "static/media/success-whitecheck-mark.bec7cf72.svg";